import styled from 'styled-components';
import IconMirrorStatusActive from './assets/status-Active.svg';
import IconMirrorStatusError from './assets/status-Error.svg';
import IconMirrorStatusInitializing from './assets/status-Initializing.svg';
import IconMirrorStatusPaused from './assets/status-Paused.svg';
import IconMirrorStatusRetrying from './assets/status-Retrying.svg';
import type { ApiMirrorRegistryStatus } from '@fabric-app/types/connections';

/**
 * Don't use this directly, rather use MirrorRegistryStatusIndicator
 */
export const MirrorRegistryStatusIconMap: Record<
  ApiMirrorRegistryStatus,
  React.FunctionComponent<React.SVGProps<SVGSVGElement>>
> = {
  active: IconMirrorStatusActive,
  failed: IconMirrorStatusError,
  paused: IconMirrorStatusPaused,
  initializing: IconMirrorStatusInitializing,
  retrying: IconMirrorStatusRetrying,
};

interface Props {
  status: ApiMirrorRegistryStatus;
}

/**
 * DO NOT USE DIRECTLY, use MirrorRegistryStatusIndicator instead
 * the icon is wrapped with a div
 * custom Tooltip doesn't work with the svgs
 */
export const MirrorRegistryStatusIcon = styled.div.attrs<Props>((props: Props) => {
  const IconComponent = MirrorRegistryStatusIconMap[props.status];
  return {
    ...props,
    children: <IconComponent />,
    alt: props.status,
  };
})``;
